import type { DentalCaseJaws, JawType } from "../../types/dental";

interface DebugPanelProps {
  isOpen: boolean;
  activeJaw: JawType;
  editableJaws: DentalCaseJaws | null;
  onClose: () => void;
  onUpdateActiveJawArch: (
    key: "width" | "depth" | "height" | "toothCount",
    value: number
  ) => void;
  onTestWasm: () => void | Promise<void>;
}

export function DebugPanel({
  isOpen,
  activeJaw,
  editableJaws,
  onClose,
  onUpdateActiveJawArch,
  onTestWasm,
}: DebugPanelProps) {
  if (!isOpen || !editableJaws) {
    return null;
  }

  const activeArch = editableJaws[activeJaw];

  return (
    <div className="debug-popover" role="dialog" aria-label="Debug Controls">
      <div className="debug-panel">
        <div className="debug-panel__header">
          <div>
            <h3>Debug Controls</h3>
            <div className="debug-panel__subheading">
              Editing {activeJaw} jaw
            </div>
          </div>

          <button
            type="button"
            className="debug-panel__close"
            onClick={onClose}
            aria-label="Close debug controls"
          >
            ✕
          </button>
        </div>

        <div className="debug-panel__note">
          Simulation only. Real cases will use scan-derived geometry.
        </div>

        <div className="field-stack field-stack--compact">
          <div className="field-row field-row--compact">
            <label>Arch Width ({activeArch.width})</label>
            <input
              type="range"
              min="60"
              max="140"
              value={activeArch.width}
              onChange={(e) =>
                onUpdateActiveJawArch("width", Number(e.target.value))
              }
            />
          </div>

          <div className="field-row field-row--compact">
            <label>Arch Depth ({activeArch.depth})</label>
            <input
              type="range"
              min="20"
              max="80"
              value={activeArch.depth}
              onChange={(e) =>
                onUpdateActiveJawArch("depth", Number(e.target.value))
              }
            />
          </div>

          <div className="field-row field-row--compact">
            <label>Arch Height ({activeArch.height})</label>
            <input
              type="range"
              min="-20"
              max="40"
              value={activeArch.height}
              onChange={(e) =>
                onUpdateActiveJawArch("height", Number(e.target.value))
              }
            />
          </div>

          <div className="field-row field-row--compact">
            <label>Tooth Count ({activeArch.toothCount})</label>
            <input
              type="range"
              min="8"
              max="16"
              value={activeArch.toothCount}
              onChange={(e) =>
                onUpdateActiveJawArch("toothCount", Number(e.target.value))
              }
            />
          </div>

          <div className="field-row field-row--compact">
            <button
              type="button"
              className="debug-panel__action"
              onClick={() => {
                void onTestWasm();
              }}
            >
              Test WASM Crown Solve
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}